export { CollapseDirective } from './collapse.directive';
export { CollapseModule } from './collapse.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/ng2-bootstrap/collapse/index.js
// module id = ../../../../ng2-bootstrap/collapse/index.js
// module chunks = 4